export class Paragraph {
	public title: string;
	public class: string;
	public order: number;
	public text: [string];
	public image: string;
	public image_position: string;

	constructor(
		private atitle: string,
		private aclass: string,
		private aorder: number, 
		private atext: [string],
		private aimage: string,
		private aimage_position: string){

		this.title = atitle;
		this.class = aclass;
		this.order = aorder;
		this.text = atext;
		this.image = aimage;
		this.image_position = aimage_position;
	}

}
